import React, { useState } from 'react';
import useChrModal from './useChrModal';
import useRemoteDataFetcher from '../PageUI/useRemoteDataFetcher';
import ChrWidgetLoaders from '../../../components/generic/PageUI/Basic/Widget/ChrWidgetLoaders';

/*
props = {
  dataPath: <string>,
  ModalBodyComponent: <Component>,
}
*/

const useChrRemoteModal = (props) => {
  const { dataPath, urlOptions, ModalBodyComponent = () => null, modalData = {}, loaderCount = 3, remoteDataReader, remoteDataWriter, loaderProps = {} } = props;
  const { ChrModal, modalOptions, modalControls } = useChrModal(props);
  const [canFetchData, setCanFetchData] = useState(false);
  const { fetchCondition = (() => canFetchData), fetchOnlyOnce = true } = props;
  const { dependencies: dependenciesFromProps = [] } = props;
  const dependencies = [...dependenciesFromProps, canFetchData].filter((item, index, self) => self.indexOf(item) === index);

  const { remoteData, contentLoaded } = useRemoteDataFetcher({
    remoteOptions: { url: dataPath, urlOptions: urlOptions },
    fetchOnlyOnce,
    dependencies,
    isContentLoaded: props.isContentLoaded,
    fetchCondition,
    remoteDataReader,
    remoteDataWriter
  });

  const modalBody = contentLoaded ? <ModalBodyComponent data={{...modalData, ...remoteData}} modalControls={modalControls} /> : <ChrWidgetLoaders rows={loaderCount} {...loaderProps} />

  const remoteModalOptions = {
    ...modalOptions,
    body: modalBody,
    noAnimation: true
  };

  const showRemoteModal = () => {
    setCanFetchData(true);
    modalControls.showModal();
  };

  const remoteModalActions = {
    showRemoteModal,
    hideRemoteModal: modalControls.hideModal,
    toggleSoftHiddenStatus: modalControls.toggleSoftHiddenStatus
  }

  return {
    ChrRemoteModal: ChrModal,
    remoteModalOptions,
    remoteModalActions
  };
};

export default useChrRemoteModal;
